// extracted by mini-css-extract-plugin
export default {"form":"FAQForm_form__hfJQv","buttonsCont":"FAQForm_buttonsCont__YQL-y","buttonOut":"FAQForm_buttonOut__uj3l5"};